import { render } from "./BaseTitle.vue?vue&type=template&id=4636e23f"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__